import { Component } from '@angular/core';
import { AuthService } from '@core/auth';

@Component({
    selector: 'navbar',
    standalone: false,
    templateUrl: './navbar.component.html',
    styleUrl: './navbar.component.css'
})
export class NavbarComponent {

    constructor(public authService: AuthService) { }

}
